import { createFileRoute } from "@tanstack/react-router";
import { useSite } from "@/components/site/site-data";
import { PageHeader } from "@/components/site/PageHeader";
import { PartnersStripView } from "@/components/site/PartnersStripView";

export const Route = createFileRoute("/parteneri")({
  head: () => ({
    meta: [
      { title: "Parteneri — InvesTenergy 2026" },
      {
        name: "description",
        content:
          "Partenerii Conferinței anuale InvesTenergy 2026 și ai Galei Specialiștilor din Energie: patronaj ANRE, parteneri oficiali, Gold, Silver și parteneri media.",
      },
      { property: "og:title", content: "Parteneri — InvesTenergy 2026" },
      {
        property: "og:description",
        content: "Partenerii dau plus valoare Conferinței anuale InvesTenergy.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: Parteneri,
});

function Parteneri() {
  const { blocks, tiers, partners } = useSite();

  return (
    <main>
      <PageHeader title="Parteneri" subtitle={blocks["parteneri_intro"]?.body ?? ""} />
      <PartnersStripView
        tiers={tiers}
        partners={partners}
        className="bg-white py-16"
        containerClassName="mx-auto max-w-6xl space-y-14 px-6"
      />
    </main>
  );
}
